/**
 * @generated SignedSource<<3033489bef8f083bdeeef3fb7b3cf208>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBuildState = "DISABLED" | "PENDING_BRAND_SETUP" | "PENDING_KINN_SETUP" | "PRE_PRODUCTION" | "PRODUCTION" | "%future added value";
export type InternBrandQuery$variables = {
  id: string;
};
export type InternBrandQuery$data = {
  readonly brand: {
    readonly appConfig: {
      readonly appState: AppBuildState;
    };
    readonly displayName: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"InternBrandBilling_brand" | "InternBrandBuilds_brand" | "InternBrandDashboard_brand" | "InternBrandOnboarding_brand">;
  };
};
export type InternBrandQuery = {
  response: InternBrandQuery$data;
  variables: InternBrandQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appState",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takeRate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takeRateTotalCap",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takeRateMinUsage",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBlocking",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandBilling_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandBuilds_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandDashboard_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandOnboarding_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppBuild",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidAppVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidAppBuild",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAscTeamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAscKeyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAscIssuerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appTrackingDialogEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidAppIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "azureNotificationsHubName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosPushNotificationServiceKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosPushNotificationServiceKeyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidPushNotificationFcmv1PrivateKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidPushNotificationFcmv1ProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidPushNotificationFcmv1ClientEmail",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLBillingConfig",
            "kind": "LinkedField",
            "name": "billingConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planCreatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planTrialDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planCurrency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planInterval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLPendingBillingConfig",
                "kind": "LinkedField",
                "name": "pendingBillingConfig",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isImmediate",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "interval",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trialDays",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLShopifyBillingConfig",
                "kind": "LinkedField",
                "name": "shopifyBillingConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appSubscriptionLineItemId",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLOneTimePurchaseCharge",
                "kind": "LinkedField",
                "name": "oneTimePurchaseCharges",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "chargeId",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appleDeveloperAgreementsPendingSince",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showIosTosAlert",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosPushNotificationCredentialsSetInAzure",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosPushNotificationCredentialsRequireServiceKeyMigration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosPushNotificationCertExpirationDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "androidPushNotificationCredentialsSetInAzure",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "androidPushNotificationRequiresFcmv1Migration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandPushNotificationStats",
            "kind": "LinkedField",
            "name": "pushNotificationStats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationsSent30d",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pushDeliveries30d",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pushTaps30d",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tapRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalRegisteredDevices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosDevices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidDevices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PushNotificationDailyMetric",
                "kind": "LinkedField",
                "name": "dailyMetrics",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveries",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taps",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filters",
                "value": {
                  "os": {
                    "isNull": true
                  }
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 30
              }
            ],
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandMetricDailyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLBrandMetricDaily",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appSales",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appSessions",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newAppUsers",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "metricsDaily(filters:{\"os\":{\"isNull\":true}},first:30)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandOrderMetricsSummary",
            "kind": "LinkedField",
            "name": "orderMetricsSummary",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalOrders",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kinnOrders",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attributionRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLFacebookClientConfig",
            "kind": "LinkedField",
            "name": "facebookConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "needsReauth",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "domain",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "67734708480871d38c837e9b0019fcf4",
    "id": null,
    "metadata": {},
    "name": "InternBrandQuery",
    "operationKind": "query",
    "text": "query InternBrandQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    id\n    displayName\n    appConfig {\n      appState\n      id\n    }\n    ...InternBrandBilling_brand\n    ...InternBrandBuilds_brand\n    ...InternBrandDashboard_brand\n    ...InternBrandOnboarding_brand\n  }\n}\n\nfragment InternAgreementsCard_brand on BrandType {\n  id\n  appleDeveloperAgreementsPendingSince\n  showIosTosAlert\n}\n\nfragment InternBrandActivityChart_brand on BrandType {\n  metricsDaily(filters: {os: {isNull: true}}, first: 30) {\n    edges {\n      node {\n        date\n        appSessions\n        appSales\n        newAppUsers\n        id\n      }\n    }\n  }\n}\n\nfragment InternBrandBillingOneTimePurchaseCard_brand on BrandType {\n  id\n  billingConfig {\n    id\n    oneTimePurchaseCharges {\n      id\n      isBlocking\n      status\n      currency\n      chargeId\n      price\n      createdAt\n      name\n    }\n  }\n}\n\nfragment InternBrandBillingRecurringSubCard_billingConfig on GraphQLBillingConfig {\n  id\n  planCreatedAt\n  planTrialDays\n  planCurrency\n  planId\n  planInterval\n  planPrice\n  planStatus\n  startDate\n  takeRate\n  takeRateTotalCap\n  takeRateMinUsage\n  pendingBillingConfig {\n    id\n    isBlocking\n    isImmediate\n    createdAt\n    currency\n    price\n    interval\n    takeRate\n    takeRateTotalCap\n    takeRateMinUsage\n    trialDays\n  }\n  shopifyBillingConfig {\n    appSubscriptionLineItemId\n    id\n  }\n}\n\nfragment InternBrandBilling_brand on BrandType {\n  id\n  billingConfig {\n    ...InternBrandBillingRecurringSubCard_billingConfig\n    id\n  }\n  ...InternBrandBillingOneTimePurchaseCard_brand\n}\n\nfragment InternBrandBuilds_brand on BrandType {\n  id\n  appConfig {\n    appName\n    iosAppVersion\n    iosAppBuild\n    androidAppVersion\n    androidAppBuild\n    ...InternBuildConfigPanel_appConfig\n    id\n  }\n}\n\nfragment InternBrandDashboard_brand on BrandType {\n  id\n  ...InternAgreementsCard_brand\n  ...InternNotificationsCard_brand\n  ...InternBrandStatCards_brand\n  ...InternBrandActivityChart_brand\n  ...InternIntegrationsCard_brand\n}\n\nfragment InternBrandOnboarding_brand on BrandType {\n  id\n  domain\n}\n\nfragment InternBrandStatCards_brand on BrandType {\n  metricsDaily(filters: {os: {isNull: true}}, first: 30) {\n    edges {\n      node {\n        date\n        appSales\n        appSessions\n        newAppUsers\n        id\n      }\n    }\n  }\n  orderMetricsSummary {\n    totalOrders\n    kinnOrders\n    attributionRate\n  }\n}\n\nfragment InternBuildConfigPanel_appConfig on BrandAppConfigType {\n  appName\n  iosAppIdentifier\n  iosAscTeamId\n  iosAscKeyId\n  iosAscIssuerId\n  appTrackingDialogEnabled\n  androidAppIdentifier\n}\n\nfragment InternIntegrationsCard_brand on BrandType {\n  id\n  facebookConfig {\n    id\n    needsReauth\n  }\n}\n\nfragment InternNotificationsCard_brand on BrandType {\n  id\n  displayName\n  iosPushNotificationCredentialsSetInAzure\n  iosPushNotificationCredentialsRequireServiceKeyMigration\n  iosPushNotificationCertExpirationDate\n  androidPushNotificationCredentialsSetInAzure\n  androidPushNotificationRequiresFcmv1Migration\n  pushNotificationStats {\n    notificationsSent30d\n    pushDeliveries30d\n    pushTaps30d\n    tapRate\n    totalRegisteredDevices\n    iosDevices\n    androidDevices\n    dailyMetrics {\n      date\n      deliveries\n      taps\n    }\n  }\n  appConfig {\n    id\n    azureNotificationsHubName\n    iosAscTeamId\n    iosAppIdentifier\n    iosPushNotificationServiceKey\n    iosPushNotificationServiceKeyId\n    androidPushNotificationFcmv1PrivateKey\n    androidPushNotificationFcmv1ProjectId\n    androidPushNotificationFcmv1ClientEmail\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d68d4dc7a9c2450c194456785f61ab9";

export default node;
